import module from 'finanzas/module.js'
import template from './template.html'

var options = {}
var cache

module.config(($stateProvider) => {
  $stateProvider.state('finances.gastosVsBancos', {
    url: '/gastosVsBancos',
    data: {
      title: 'Gastos vs bancos',
    },
    template,
    controllerAs: 'ctrl',
    controller ($moment, FinanzasGastosVsBancos, Catalogs, $notify) {
      var ctrl = this
      ctrl.References = cache
      ctrl.processing = false
      ctrl.options = options
      ctrl.options.date = ctrl.options.date || $moment().startOf('month').toDate()
      ctrl.catalogos = {
        Bancos: Catalogs.Bancos,
      }

      ctrl.$query = function () {
        ctrl.processing = true
        FinanzasGastosVsBancos.$select(ctrl.options.date).then(function (References) {
          cache = ctrl.References = References
        }).catch(function (error) {
          $notify.error(error)
        }).finally(function () {
          ctrl.processing = false
        })
      }
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/gastosVsBancos/finances-gastosVsBancos.js